import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Helpers
import { getTargetOptions } from '../core/target_local_options';
import { isWallDisplay } from 'src/helpers/interface_helpers';
//Types
import type { ActionJob, LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';
import type { Device } from 'src/types/Device';

export const getSwitchLocalActions = (
	action: ActionJob,
	mainDevice: Device,
	params: { id: number },
): LocalControlOptions[] => {
	const $format = get(format);
	const onOffStateParams = {
		id: params.id,
		on: action.params?.on || false,
		toggle_after: action.params?.toggle_after || 0,
	};
	const attr = { target: getTargetOptions(mainDevice) };
	const toggleAfterAttr = {
		...attr,
		toggle_after: Boolean(action?.params?.toggle_after),
	};

	const localActions: LocalControlOptions[] = [
		{
			title: $format('local_action_control_output', {
				default: 'Control Output',
			}),
			value: 'switch.set',
			attr: toggleAfterAttr,
			params: onOffStateParams,
			onOffState: {
				checked: true,
				selectBox: false,
				label: $format('label_light_state', {
					default: 'Light State',
				}),
			},
		},
	];

	// Wall display devices do not support toggle command
	if (!isWallDisplay(mainDevice.type)) {
		localActions.push({
			title: $format('local_action_toggle_output', {
				default: 'Toggle Output',
			}),
			value: 'switch.toggle',
			attr,
			params,
		});
	}

	return localActions;
};
